<template>

	<svg width="254" height="111" viewBox="0 0 254 111" fill="none" xmlns="http://www.w3.org/2000/svg">
		
		<path id="back-meter" d="M207 107C207 62.8172 171.183 27 127 27C82.8172 27 47 62.8172 47 107" stroke="#D9E4EB" stroke-width="16" stroke-dasharray="2 2"/>

		<path 
			id="front-meter" 
			d="M207 107C207 62.8172 171.183 27 127 27C82.8172 27 47 62.8172 47 107" 
			:stroke="'url(#' + uid + ')'" 
			stroke-width="16" 
			:stroke-dasharray="dasharray" 
			:stroke-dashoffset="dashoffset"
		/>
		<!-- 
			251 — длина всего полукруга в пикселях.
			stroke-dasharray: 25 — длина в пикселях. Берём 251 за 100% и рассчитываем, исходя из этого. 226 получаем вычитая 25 из 251 — это длина разрыва.
			stroke-dashoffset: адаём то же значение что и длина разрыва только с противоположным знаком, в нашем случае -226.
		 -->
		<g id="arrow" :style="{'transform': 'rotate(' + rotate + 'deg)'}">
			<circle cx="127.333" cy="106" r="5" :fill="color" />
			<path d="M126.833 45H127.833L129.333 106H125.333L126.833 45Z" :fill="color"/>
		</g>
		<g id="percents">
			<text x="15" y="107" class="percents" :style="{'fill': progress >= 0 ? color : '#AEC1CC'}">0%</text>
			<text x="117" y="10" class="percents" :style="{'fill': progress >= 50 ? color : '#AEC1CC'}">50%</text>
			<text x="224" y="107" class="percents" :style="{'fill': progress >= 100 ? color : '#AEC1CC'}">100%</text>
		</g>
		
		<defs>
			<linearGradient :id="uid" x1="127" y1="29.4" x2="35.8" y2="107" gradientUnits="userSpaceOnUse">
				<stop :offset="(100 - progress) / 100" :stop-color="color"/> 
				<stop offset="1" stop-color="white"/>
			</linearGradient>
		</defs>
	</svg>
</template>


<script>

	export default {

	    name: 'SpeedometerSmall',
    	
    	props: ['progress', 'color'],

	    data: () => ({
	    	uid: null,
	    }),

	    created () {
	    	this.uid = "id" + Math.random().toString(16).slice(2);
	    },

	    computed: {
	    	

	    	dasharray () {
	    		const q = 251 / 100 * this.progress;
	    		const s = 251 - q;
	    		return q + ' ' + s;
	    	},

	    	dashoffset () {
	    		return 251 - 251 / 100 * this.progress * -1;
	    	},

	    	rotate () {
	    		return this.progress * 1.8 - 90;
	    	}

	    },

	}

</script>




<style scoped>
	.percents {
		font-size: 10px;
		font-weight: 600;
		fill: #AEC1CC;
	}
	#arrow, #front-meter {
		transform-origin: 127px 106px;
	}
	#arrow, #front-meter {
		transition: all .5s ease-out;
	}
</style>